// extracted by mini-css-extract-plugin
export var activityContainer = "_mc-0";
export var typingIndicatorContainer = "_mc-1";
export var typingIndicatorDot = "_mc-2";
export var wave = "_mc-3";